import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import type { PortfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

export const isPortfolioListNarrowed = (filter: PortfolioFilterState) =>
	filter.categories.length > 0 ||
	filter.contractState === PORTFOLIO_CONTRACT_STATE.archived;
